// One-shot hand-off of the choices made in the "Join" dialog to the pre-join screen.

export interface JoinPrefs {
  name: string;
  audioMuted: boolean;
  videoOff: boolean;
}

let pending: JoinPrefs | null = null;

export function setJoinPrefs(prefs: JoinPrefs): void {
  pending = prefs;
}

export function takeJoinPrefs(): JoinPrefs | null {
  const p = pending;
  pending = null;
  return p;
}
